<script>
	import { Router, Link, Route } from "svelte-routing";
	import Home from "./routes/+page.svelte";
	import About from "./routes/About.svelte";
	import Legal from "./routes/Legal.svelte";
	import Login from "./routes/Login.svelte";
	import Profile from "./routes/Profile.svelte";
	import BrfPage from "./routes/brf/[id].svelte";

	export let url = "";
</script>

<Router {url}>
	<nav>
		<Link to="/">Home</Link>
		<Link to="/about">About</Link>
		<Link to="/legal">Legal</Link>
		<Link to="/login">Login</Link>
		<Link to="/profile">Profile</Link>
	</nav>
	<div>
		<Route path="/about" component={About} />
		<Route path="/legal" component={Legal} />
		<Route path="/login" component={Login} />
		<Route path="/profile" component={Profile} />
		<Route path="/brf/:id" let:params>
			<BrfPage id={params.id} />
		</Route>
		<Route path="/brf/:id/:name" let:params>
			<BrfPage id={params.id} />
		</Route>
		<Route path="/"><Home /></Route>
	</div>
</Router>

<style>
	nav {
		display: none;
	}
</style>